import _isEmpty from 'lodash/isEmpty';
import { DAYS_BY_VALUE } from './constants';
export function isHourEqual(firstHour, secondHour) {
  var firstOpenTime = firstHour.openTime,
    firstCloseTime = firstHour.closeTime;
  var secondOpenTime = secondHour.openTime,
    secondCloseTime = secondHour.closeTime;
  return firstOpenTime === secondOpenTime && firstCloseTime === secondCloseTime;
}
export function areHoursEqual() {
  var firstHours = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var secondHours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (firstHours.length !== secondHours.length) {
    return false;
  }
  for (var i = 0; i < firstHours.length; i += 1) {
    if (!isHourEqual(firstHours[i], secondHours[i])) {
      return false;
    }
  }
  return true;
}
function isHourDefined() {
  var hour = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var startDay = hour.startDay,
    closeTime = hour.closeTime,
    openTime = hour.openTime;
  return !_isEmpty(startDay) && !_isEmpty(closeTime) && !_isEmpty(openTime);
}
function areDaysContiguous(firstDay, secondDay) {
  var firstIndex = DAYS_BY_VALUE[firstDay];
  var secondIndex = DAYS_BY_VALUE[secondDay];
  return Math.abs(firstIndex - secondIndex) === 1;
}
export function groupHours() {
  var hours = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var hoursByDay = {};
  hours.forEach(function (hour) {
    if (isHourDefined(hour)) {
      var day = hour.startDay;
      if (!hoursByDay[day]) {
        hoursByDay[day] = [hour];
      } else {
        hoursByDay[day].push(hour);
      }
    }
  });
  var days = Object.keys(hoursByDay).sort();
  var daysLength = days.length;
  var hoursByDays = {};
  var i = 0;
  while (i < daysLength) {
    var currentDay = days[i];
    var currentHours = hoursByDay[currentDay];
    var aggregatedDay = [currentDay];
    for (var j = i + 1; j < daysLength; j += 1) {
      var nextDay = days[j];
      var nextDayHours = hoursByDay[nextDay];
      var hoursAreEqual = areHoursEqual(currentHours, nextDayHours);
      var daysAreContiguous = areDaysContiguous(currentDay, nextDay);
      if (!hoursAreEqual || !daysAreContiguous) {
        break;
      }
      aggregatedDay.push(nextDay);
      currentDay = days[j];
    }
    hoursByDays[aggregatedDay] = currentHours;
    i += aggregatedDay.length;
  }

  // transform dictionary into a list
  return Object.keys(hoursByDays).sort().map(function (day) {
    return {
      day: day,
      hours: hoursByDays[day]
    };
  });
}